/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'i18n!./DashboardCommonResources',
	'../lib/@waca/core-client/js/core-client/utils/Lexicon'
], function (localeResources, Lexicon) {
	'use strict';

	var lexicon = new Lexicon({
		data: localeResources,
		verbose: true
	});

	var StringResources = function () {
		return undefined;
	};

	/**
	 * Get the string resource for the given key and interpolation options
	 *
	 * @param key						The  key of the string to return
	 * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
	 * @returns							The string to display
	 */
	StringResources.prototype.get = function (key, interpolationOptions) {
		return lexicon.translate(key, interpolationOptions);
	};

	return new StringResources();
});
